import {notification} from "antd";

// PRINT TYPES
export const ERROR = "error"
export const WARNING = "warning"
export const INFO = "info"

// DEFAULTS
export const PAGINATION_DEFAULT_PAGE=1
export const PAGINATION_DEFAULT_SIZE=12

export const wrapResponse = (promise: Promise<any>) => {
    promise
        .then(() => notification.success({
            message: 'Успешно',
            duration: 5
        }))
        .catch(error => notification.error({
            message: `Ошибка: ${error.status}`,
            description: error.data.message,
            duration: 5
        }))
}



export const asyncWrapResponse = (promise: Promise<any>,block: ()=> void) => {
    promise
        .then(() => {
            notification.success({
                message: 'Успешно',
                duration: 5
            })
            block()
        })
        .catch(error => notification.error({
            message: `Ошибка: ${error.status}`,
            description: error.data.message,
            duration: 5
        }))
}

export const convertParam = (name: string, params: any[] | undefined) => {
    if (!params || !params[0]) return ''

    return `&${name}=${params.join(',')}`
}

export interface DeleteParams {
    id: number | string | undefined,
    accountId?: number | undefined
}
